import {ActionContext} from "vuex";
import {State as RootState} from "@/store";
import {getStoreAccessors} from "vuex-typescript";
import {Post} from "@/repository/messagehub.dtos";
import {PostState} from "@/store/Posts/PostState";

type PostRecordContext = ActionContext<PostState, RootState>;

export const postRecord = {
    namespaced: true,

    state: {
        posts: [],
        selectedPost: null
    },

    getters: {
        getPosts(state: PostState): any{
            let posts =  state.posts
            if (!posts){
                return []
            }
            else{
                return state.posts
            }
        },
        getSelectedPost(state: PostState): any {
            return state.selectedPost
        }
    },

    mutations: {
        mutateAddPost: function(state: PostState, newPost: Post){
            if (state.posts !=null && state.posts.length >0){
                console.log('add post')
                state.posts.push(newPost)
                state.selectedPost = newPost
            }
            else{
                state.posts = []
                state.posts.push(newPost)
                state.selectedPost = newPost
            }

        },
        mutateDeletePost: function(state: PostState, deletedPost: Post){
          if (state.posts !=null && state.posts.length >0)  {
              let idx:number = state.posts.indexOf(deletedPost);
              if (idx != -1) {
                  state.posts.splice(idx,1)
                  state.selectedPost = null
              }
          }
        },
        mutateDeletePostById: function(state: PostState, deletedPostId: string){
            if (state.posts !=null && state.posts.length >0)  {
                state.posts.forEach(f=>{
                  if (f.id == deletedPostId){
                      mutations.mutateDeletePost(state, f)
                      if (state.selectedPost && state.selectedPost.id == deletedPostId)
                      {
                          state.selectedPost = null;
                      }
                  }
                })
            }
        },
        mutateInitializePosts: function(state: PostState, posts: Post[]){
            state.posts = posts

            if (state.posts.length>0){
                state.selectedPost = posts[0]
            }
            else{
                state.selectedPost = null;
            }

        },
        mutateSelectedPostChanged:function(state: PostState, selectedPost: Post){
            state.selectedPost = selectedPost
        },
        mutateUpdatePost: function(state: PostState, updatedPost: Post){

            if (state.posts !=null && state.posts.length >0)  {
                if (state.selectedPost !=null){
                    let idx:number = state.posts.indexOf(state.selectedPost);
                    if (idx != -1) {
                        state.posts.splice(idx,1)
                        state.posts.push(updatedPost)
                        state.selectedPost = null
                    }
                }
            }
            else{
                state.posts = []
                state.posts.push(updatedPost)
            }
            state.selectedPost = updatedPost
        },
    },

    actions: {
        addPost: function (context: PostRecordContext, newPost: Post){
            commitAddPost(context, newPost)
        },
        deletePost: function (context: PostRecordContext, deletedPost: Post){
            commitDeletePost(context, deletedPost)
        },
        deletePostById: function (context: PostRecordContext, deletedPostId: string){
            commitDeletePostById(context, deletedPostId)
        },
        initializePosts: function (context: PostRecordContext, posts: Post[]){
            commitInitializePosts(context, posts)
        },
        selectedPostChanged: function (context: PostRecordContext, selectedPost: Post){
            commitSelectedPostChanged(context, selectedPost)
        },
        updatePost: function (context: PostRecordContext, postTopic: Post){
            commitUpdatePost(context, postTopic)
        },

    },
};
const { commit, read, dispatch } =
    getStoreAccessors<PostState, RootState>("postRecord");

const getters:any = postRecord.getters;
export const getPosts:any = read(getters.getPosts);
export const getSelectedPosts:any = read(getters.getSelectedPost);

const actions: any = postRecord.actions;
export const deletePost:any =dispatch(actions.deletePost)
export const initializePosts:any =dispatch(actions.initializePosts)
export const selectedPostChanged:any =dispatch(actions.selectedPostChanged)
export const addPost:any =dispatch(actions.addPost)
export const updatePost:any =dispatch(actions.updatePost)
export const deletePostById: any = dispatch(actions.deletePostById)

const mutations:any = postRecord.mutations;
export const commitDeletePost:any = commit(mutations.mutateDeletePost);
export const commitInitializePosts:any = commit(mutations.mutateInitializePosts);
export const commitSelectedPostChanged:any = commit(mutations.mutateSelectedPostChanged);
export const commitAddPost:any = commit(mutations.mutateAddPost);
export const commitUpdatePost:any = commit(mutations.mutateUpdatePost);
export const commitDeletePostById: any = commit(mutations.mutateDeletePostById)
